import { useEffect, useState } from 'react'
import { isMobile as isMobileDevice } from 'react-device-detect'

const DEFAULT_BREAKPOINT = 768

const buildQuery = (breakpoint) =>
    `(max-width: ${breakpoint}px), (max-height: ${breakpoint}px) and (orientation: landscape) and (pointer: coarse)`

const useIsMobile = (breakpoint = DEFAULT_BREAKPOINT) => {
    const query = buildQuery(breakpoint)

    const [isMobile, setIsMobile] = useState(
        () =>
            isMobileDevice ||
            (typeof window !== 'undefined' &&
                window.matchMedia(query).matches)
    )

    useEffect(() => {
        if (isMobileDevice) {
            setIsMobile(true)
            return undefined
        }

        if (typeof window === 'undefined') return undefined

        const mediaQuery = window.matchMedia(query)
        const handleChange = (event) => setIsMobile(event.matches)

        setIsMobile(mediaQuery.matches)

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', handleChange)
            return () => mediaQuery.removeEventListener('change', handleChange)
        }

        mediaQuery.addListener(handleChange)
        return () => mediaQuery.removeListener(handleChange)
    }, [query])

    return isMobile
}

export default useIsMobile
